/* eslint-disable no-console */
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { BaseLoginInfo } from "./user.service";

export interface AuthEvent {
  type: "LOGIN_COMPLETED" | "LOGOUT_COMPLETED";
  loginInfo?: BaseLoginInfo;
  timestamp: Date;
}

@Injectable({
  providedIn: "root"
})
export class AuthEventsService {
  private authEventsSubject = new Subject<AuthEvent>();
  
  /**
   * Observable stream of authentication events
   */
  public authEvents$ = this.authEventsSubject.asObservable();

  /**
   * Emit a login completed event
   * This should be called after successful login (including MFA completion)
   */
  public emitLoginCompleted(loginInfo: BaseLoginInfo): void {
    
    const event: AuthEvent = {
      type: "LOGIN_COMPLETED",
      loginInfo,
      timestamp: new Date()
    };
    
    this.authEventsSubject.next(event);
  }

  /**
   * Emit a logout completed event  
   * This should be called after successful logout
   */
  public emitLogoutCompleted(): void {
    
    const event: AuthEvent = {
      type: "LOGOUT_COMPLETED",
      timestamp: new Date()
    };
    
    this.authEventsSubject.next(event);
  }
}
